// Generische Bottom-Action-Bar der App-Shell — Phones (hoch + quer) UND
// seit T2 das Tablet-Band 640–1023. Seit T3 registrieren die Seiten ihre
// Bottom-Slots in BEIDEN Welten (MobileBottomSlots gated auf useShellBars)
// — im Band zusätzlich zu den sichtbaren Desktop-Köpfen (Daumen-Redundanz
// per Design). Slot 1 ist IMMER ☰ (Daumen-Toggle unten links; das
// Schließen sitzt beim geöffneten Drawer an derselben Stelle, sidebar.tsx
// onClose), danach das Portal-Outlet für die Seiten-Slots
// (MobileBottomSlots). Ohne registrierte Slots = Minimal-Bar: ☰ + freier
// Raum — auch read-only-Seiten behalten so den Menüzugang und die
// Bar-Position springt beim Navigieren nie.
//
// Flex-Kind der main-Spalte, KEIN position:fixed: der Scroller endet
// physisch an der Bar-Oberkante → kein pb-Hack, Listenenden können
// konstruktionsbedingt nie verdeckt werden. Die Zeile ist
// h-14 = 56px = MOBILE_BAR_HEIGHT (ui/mobile-action-bar.tsx); das
// Safe-Area-Home-Indicator-Inset trägt die Bar selbst (inline, Muster
// side-panel/dialog) — die alte .main-content-standalone-Regel ist darum
// auf ≥1024 gescoped (sonst Doppel-Inset; seit T2 läuft die Bar bis 1023).

import { Menu } from 'lucide-react'
import { useShellStore } from '../../lib/shell-store'
import { BarSlot } from '../ui/mobile-action-bar'
import { useShellOutletStore } from './mobile-shell-outlets'

export function MobileShellBottom() {
  const openDrawer = useShellStore((s) => s.openDrawer)
  const drawerOpen = useShellStore((s) => s.drawerOpen)
  const suppressed = useShellStore((s) => s.suppressBottomBar)
  const setBottomSlotsEl = useShellOutletStore((s) => s.setBottomSlotsEl)
  const hasSlots = useShellOutletStore((s) => s.bottomSlotsCount > 0)

  // Composer-Fokus (z.B. Chat, Risiko §5.2): Bar komplett raus, damit sie
  // auf Android nicht als toter Streifen zwischen Eingabefeld und Tastatur
  // hängt. Der Scroller wächst um die 56px — Blur stellt sie wieder her.
  if (suppressed) return null

  return (
    <nav
      aria-label="Seiten-Aktionen"
      className="shell-safe-inline shrink-0 border-t border-border-subtle bg-bg-elevated"
      style={{ paddingBottom: 'var(--app-safe-bottom)' }}
    >
      <div className="flex h-14 items-stretch">
        {/* ── ☰: Shell-fixer Slot 1 auf jeder Seite ── */}
        <BarSlot
          label="Menü"
          icon={<Menu className="h-5 w-5" />}
          ariaLabel="Seitenleiste öffnen"
          ariaExpanded={drawerOpen}
          onClick={openDrawer}
        />

        {/* ── Portal-Outlet: display:contents — portalte BarSlots/
            BarAccentPlus werden echte Flex-Kinder der h-14-Zeile und
            teilen sich die Breite wie in der Kalender-Bar. ── */}
        <div ref={setBottomSlotsEl} className="contents" />

        {/* Minimal-Bar ohne registrierte Slots: freier Raum rechts vom ☰,
            damit das ☰ seine gewohnte Slot-Breite (~1/5) behält statt die
            volle Zeile zu füllen. */}
        {!hasSlots && <div className="min-w-0 flex-[4]" aria-hidden="true" />}
      </div>
    </nav>
  )
}
